import { defineComponent, createBlock, openBlock, unref, withCtx, createVNode, normalizeClass, mergeProps, renderSlot } from "vue";
import { cn } from "../../../../node_modules/.pnpm/tailwind-variants@3.2.2_tailwind-merge@3.3.0_tailwindcss@4.1.8/node_modules/tailwind-variants/dist/index.js";
import { styleNumberValueWithUnit } from "../../../../lib/utils.js";
import _sfc_main$3 from "../../dialog/core/DialogOverlayChildren.js";
import { dialogVariants } from "../../dialog/styles/index.js";
import { u as useForwardPropsEmits } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/shared/useForwardPropsEmits.js";
import { _ as _sfc_main$1 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogPortal.js";
import { _ as _sfc_main$2 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogOverlay.js";
import { _ as _sfc_main$4 } from "../../../../node_modules/.pnpm/reka-ui@2.3.1_typescript@5.8.3_vue@3.5.16_typescript@5.8.3_/node_modules/reka-ui/dist/AlertDialog/AlertDialogContent.js";
import { reactiveOmit } from "../../../../node_modules/.pnpm/@vueuse_shared@13.3.0_vue@3.5.16_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "AlertDialogContent",
  props: {
    class: {},
    width: {},
    forceMount: { type: Boolean },
    trapFocus: { type: Boolean },
    disableOutsidePointerEvents: { type: Boolean },
    asChild: { type: Boolean },
    as: { type: [String, Object, Function] }
  },
  emits: ["escapeKeyDown", "pointerDownOutside", "focusOutside", "interactOutside", "openAutoFocus", "closeAutoFocus"],
  setup(__props, { emit: __emit }) {
    const props = __props, emits = __emit, delegatedProps = reactiveOmit(props, ["class"]), forwarded = useForwardPropsEmits(delegatedProps, emits), styleRef = computed(() => {
      if (props.width)
        return `--eci-saas-ui-dialog-content-width: ${styleNumberValueWithUnit(props.width)}`;
    }), dialogClasses = dialogVariants();
    return (_ctx, _cache) => (openBlock(), createBlock(unref(_sfc_main$1), null, {
      default: withCtx(() => [
        createVNode(unref(_sfc_main$2), {
          class: normalizeClass(unref(dialogClasses).overlay()),
          "data-slot": "alert-dialog-overlay",
          "as-child": ""
        }, {
          default: withCtx(() => [
            createVNode(_sfc_main$3)
          ]),
          _: 1
        }, 8, ["class"]),
        createVNode(unref(_sfc_main$4), mergeProps({
          class: unref(cn)(unref(dialogClasses).content(), props.class),
          style: unref(styleRef),
          "data-slot": "alert-dialog-content"
        }, unref(forwarded)), {
          default: withCtx(() => [
            renderSlot(_ctx.$slots, "default")
          ]),
          _: 3
        }, 16, ["class", "style"])
      ]),
      _: 3
    }));
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=AlertDialogContent.js.map
